import { Navigate, useParams } from 'react-router-dom'
import { useGiveaway } from '@/hooks/queries'
import { giveawayPath } from '@/lib/slug'
import { GiveawayDetailsSkeleton } from './GiveawayDetailsPage'

/**
 * `/giveaway/:idOrSlug` -> `/g/:slug`.
 *
 * The Quasar app linked giveaways at `/giveaway/{id}`, and those links are out
 * in Discord messages already. Resolving the record first means an old numeric
 * link lands on the giveaway's real slug rather than 404ing.
 */
export function LegacyGiveawayRedirect() {
  const { idOrSlug } = useParams<{ idOrSlug: string }>()
  const { data: giveaway, isPending, isError } = useGiveaway(idOrSlug)

  if (isPending) return <GiveawayDetailsSkeleton />

  if (isError || !giveaway) {
    return (
      <div className="page-giveaway-details">
        <div className="empty-state">
          <div className="empty-state-title">Giveaway unavailable</div>
          <div className="empty-state-body">That link no longer points to a giveaway.</div>
        </div>
      </div>
    )
  }

  return <Navigate to={giveawayPath(giveaway.get_slug)} replace />
}
